import { fromJS } from "immutable";
import {
  SET_MOBILE_VIEW,
  SET_ACTIVE_MARKET_PLACE,
  IS_LOADING,
} from "./constants";

const initialState = {
  is_initial_loading: true,
  mobileView: false,
  activeMarketplaces: {
    data: [],
    selected: {},
  },
};

/**
 * Define the reducer with actions
 *
 * @param {Object} state
 * @param {Object} action
 */
function SetConfigReducer(state = initialState, action) {
  switch (action.type) {
    case SET_MOBILE_VIEW:
      return {
        ...state,
        mobileView: action.data,
      };


    case IS_LOADING:
      return {
        ...state,
        is_initial_loading: action.data,
      };

    default:
      return state;
  }
}

export default SetConfigReducer;
